<template>
  <div class="globalnetwork">
    <div class="glb-main">
      <div class="glb-title" data-aos="fade-up" data-aos-duration="1000">
        <h3>全球网络</h3>
        <p>网络节点覆盖全球，每时每刻为您提供优质便捷的服务</p>
      </div>
      <div class="glb-map">
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:67px;left:91px;"></div>
          <div style="position: absolute;top:67px;left:91px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:67px;left:91px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:67px;left:91px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:103px;left:58px;"></div>
          <div style="position: absolute;top:103px;left:58px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:103px;left:58px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:103px;left:58px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:132px;left:176px;"></div>
          <div style="position: absolute;top:132px;left:176px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:132px;left:176px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:132px;left:176px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:96px;left:211px;"></div>
          <div style="position: absolute;top:96px;left:211px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:96px;left:211px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:96px;left:211px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:80px;left:248px;"></div>
          <div style="position: absolute;top:80px;left:248px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:80px;left:248px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:80px;left:248px;">
            <div class="loc"></div>
          </div>
        </div>

        <!-- point -->

        <div>
          <div class="point" style="position: absolute;top:198px;left:178px;"></div>
          <div style="position: absolute;top:198px;left:178px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:198px;left:178px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:198px;left:178px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:280px;left:277px;"></div>
          <div style="position: absolute;top:280px;left:277px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:280px;left:277px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:280px;left:277px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- EU AF -->
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:59px;left:465px;"></div>
          <div style="position: absolute;top:59px;left:465px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:59px;left:465px;">
            <div class="dott"></div>
          </div>
            <div style="position: absolute;top:59px;left:465px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:65px;left:519px;"></div>
          <div style="position: absolute;top:65px;left:519px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:65px;left:519px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:65px;left:519px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:62px;left:576px;"></div>
          <div style="position: absolute;top:62px;left:576px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:62px;left:576px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:62px;left:576px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:38px;left:616px;"></div>
          <div style="position: absolute;top:38px;left:616px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:38px;left:616px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:38px;left:616px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:142px;left:671px;"></div>
          <div style="position: absolute;top:142px;left:671px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:142px;left:671px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:142px;left:671px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:286px;left:575px;"></div>
          <div style="position: absolute;top:286px;left:575px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:286px;left:575px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:286px;left:575px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:212px;left:611px;"></div>
          <div style="position: absolute;top:212px;left:611px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:212px;left:611px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:212px;left:611px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:207px;left:906px;"></div>
          <div style="position: absolute;top:207px;left:906px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:207px;left:906px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:207px;left:906px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:198px;left:856px;"></div>
          <div style="position: absolute;top:198px;left:856px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:198px;left:856px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:198px;left:856px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:159px;left:844px;"></div>
          <div style="position: absolute;top: 159px;left: 844px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 159px;left: 844px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top: 159px;left: 844px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:142px;left:819px;"></div>
          <div style="position: absolute;top:142px;left:819px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:142px;left:819px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top:142px;left:819px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top:179px;left:935px;"></div>
          <div style="position: absolute;top:179px;left:935px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top:179px;left:935px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top:179px;left:935px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top: 279px;left: 1051px;"></div>
          <div style="position: absolute;top: 279px;left: 1051px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 279px;left: 1051px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top: 279px;left: 1051px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top: 345px;left: 1116px;"></div>
          <div style="position: absolute;top: 345px;left: 1116px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 345px;left: 1116px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top: 345px;left: 1116px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top: 112px;left: 941px;"></div>
          <div style="position: absolute;top: 112px;left: 941px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 112px;left: 941px;">
            <div class="dott"></div>
          </div>
          <div style="position: absolute;top: 112px;left: 941px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="point" style="position: absolute;top: 107px;left: 976px;"></div>
          <div style="position: absolute;top: 107px;left: 976px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 107px;left: 976px;">
            <div class="dott"></div>
          </div>
           <div style="position: absolute;top: 107px;left: 976px;">
            <div class="loc"></div>
          </div>
        </div>
        <!-- point -->
        <!-- <div>
          <div class="point" style="position: absolute;top: 154px;left: 949px;"></div>
          <div style="position: absolute;top: 154px;left: 949px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 154px;left: 949px;">
            <div class="dott"></div>
          </div>
        </div>-->
        <!-- point -->
        <!-- <div>
          <div class="point" style="position: absolute;top: 84px;left: 960px;"></div>
          <div style="position: absolute;top: 84px;left: 960px;">
            <div class="dot"></div>
          </div>
          <div style="position: absolute;top: 84px;left: 960px;">
            <div class="dott"></div>
          </div>
        </div>-->
        <!-- point -->
        <!-- <div>
          <div class="pointx" style="position: absolute;top: 199px;left: 875px;"></div>
          <div style="position: absolute;top: 199px;left: 875px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 199px;left: 875px;">
            <div class="dotxx"></div>
          </div>
        </div>-->
        <!-- point -->
        <div>
          <div class="pointx" style="position: absolute;top: 121px;left: 912px;"></div>
          <div style="position: absolute;top: 121px;left: 912px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 121px;left: 912px;">
            <div class="dotxx"></div>
          </div>
          <div style="position: absolute;top: 121px;left: 912px;">
            <div class="locx"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="pointx" style="position: absolute;top: 122px;left: 883px;"></div>
          <div style="position: absolute;top: 122px;left: 883px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 122px;left: 883px;">
            <div class="dotxx"></div>
          </div>
           <div style="position: absolute;top: 122px;left: 883px;">
            <div class="locx"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="pointx" style="position: absolute;top: 100px;left: 900px;"></div>
          <div style="position: absolute;top: 100px;left: 900px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 100px;left: 900px;">
            <div class="dotxx"></div>
          </div>
           <div style="position: absolute;top: 100px;left: 900px;">
            <div class="locx"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="pointx" style="position: absolute;top: 119px;left: 845px;"></div>
          <div style="position: absolute;top: 119px;left: 845px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 119px;left: 845px;">
            <div class="dotxx"></div>
          </div>
           <div style="position: absolute;top: 119px;left: 845px;">
            <div class="locx"></div>
          </div>
        </div>
        <!-- point -->
        <div>
          <div class="pointx" style="position: absolute;top: 146px;left: 897px;"></div>
          <div style="position: absolute;top: 146px;left: 897px;">
            <div class="dotx"></div>
          </div>
          <div style="position: absolute;top: 146px;left: 897px;">
            <div class="dotxx"></div>
          </div>
          <div style="position: absolute;top: 146px;left: 897px;">
            <div class="locx"></div>
          </div>
        </div>
        <!-- <div class="glb-caption">
          <div class="glbc-item">
            <img src="../../../assets/home/globalnetwork/海外点@2x.png" alt />
            <div>海外节点</div>
          </div>
          <div class="glbc-item">
            <img src="../../../assets/home/globalnetwork/国内点@2x.png" alt />
            <div>国内节点</div>
          </div>
        </div>-->
      </div>
      <div class="glb-data">
        <div class="glb-data-item" style="margin-right:40px">
          <div>
            <span class="num" id="count">100</span>
            <span class="plus">+</span>
          </div>
          <p class="desc">全球POP节点</p>
        </div>
        <div class="glb-data-item">
          <div>
            <span class="num" id="count2">15</span>
            <span class="plus">+</span>
          </div>
          <p class="desc">覆盖国家及地区</p>
        </div>
      </div>
    </div>
    <div class="add">
      <!-- <img src="../../../assets/home/globalnetwork/slogen.png" alt="一切为了IT更自由" data-aos="zoom-in" data-aos-duration="1000" /> -->
      <span data-aos="zoom-in" data-aos-duration="1000">网银互联｜一切为了IT更自由 </span>
    </div>
  </div>
</template>
<script>
import count from "../../../mixins/count";
export default {
  data() {
    return {
      num1: 0,
      num2: 0,
      flag: true
    };
  },
  methods: {
    add() {
      $("#count").numberRock({
        lastNumber: 52,
        duration: 18,
        easing: "swing" //慢快慢
      });
      $("#count2").numberRock({
        lastNumber:23,
        duration: 40,
        easing: "swing" //慢快慢
      });
    },
    handleScroll() {
      let scrollY = document.documentElement.scrollTop;
      if (scrollY > 1700 && this.flag) {
        this.flag = false;
        this.add();
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="less" scoped>
.globalnetwork {
  width: 100%;
  min-width: 1200px;
  background-color: #fff;
}
.glb-main {
  height: 100%;
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 80px;
  background-color: #fff;

  .glb-title {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 80px;
    text-align: center;
    padding-top: 80px;
    h3 {
      font-size: 28px;
      color: #3b3435;
    }
    p {
      margin-top: 20px;
      font-size: 18px;
      font-weight: 300;
      color: #aba1a2;
    }
  }
  .glb-map {
    height: 390px;
    width: 100%;
    position: relative;
    background-repeat: no-repeat;
    background-size: 1165px 390px;
    background-position-x: center;
    background-image: url("../../../assets/home/globalnetwork/themap.png");
    .glb-caption {
      position: absolute;
      left: 90px;
      bottom: 80px;
      height: 60px;
      width: 120px;
      .glbc-item {
        height: 30px;
        width: 120;
        img {
          width: 18px;
          height: 18px;
          margin-top: 6px;
          float: left;
        }
        div {
          line-height: 30px;
          margin-left: 30px;
          font-size: 16px;
        }
      }
    }

    // .dot:before {
    //   content: " ";
    //   position: absolute;
    //   z-index: 2;
    //   width: 10px;
    //   height: 10px;
    //   background-color: #ff4200;
    //   border-radius: 50%;
    // }
    .point {
      width: 10px;
      height: 6px;
      background-color: #b81c22;
      border-radius: 50%;
      z-index: 99;
    }
    .pointx {
      width: 10px;
      height: 6px;
      background-color: #4d5bf8;
      border-radius: 50%;
    }
    .dotx {
      content: " ";
      position: relative;
      z-index: 1;
      width: 10px;
      height: 6px;
      background-color: #4d5bf8;
      border-radius: 50%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3) inset;
      animation: ripple 1.5s infinite;
    }
    .dotxx {
      content: " ";
      position: relative;
      z-index: 1;
      width: 10px;
      height: 6px;
      background-color: #4d5bf8;
      border-radius: 50%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3) inset;
      animation: ripple 1.5s infinite;
      animation-delay: 0.4s;
    }
    .dot {
      content: " ";
      position: relative;
      z-index: 1;
      width: 10px;
      height: 6px;
      background-color: rgb(255, 83, 67);
      border-radius: 50%;
      // box-shadow: 0 0 10px rgba(0, 0, 0, 0.3) inset;

      animation: ripple 1.5s infinite;
      // animation-name: "ripple"; /*动画属性名，也就是我们前面keyframes定义的动画名*/
      // animation-duration: 1s; /*动画持续时间*/
      // animation-timing-function: ease; /*动画频率，和transition-timing-function是一样的*/
      // animation-delay: 0s; /*动画延迟时间*/
      // animation-iteration-count: infinite; /*定义循环资料，infinite为无限次*/
      // animation-direction: normal; /*定义动画方式*/
    }
    .dott {
      content: " ";
      position: relative;
      z-index: 1;
      width: 10px;
      height: 6px;
      background-color: rgb(255, 83, 67);
      border-radius: 50%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.3) inset;
      animation: ripple 1.5s infinite;
      animation-delay: 0.4s;
      // animation-name: "ripple"; /*动画属性名，也就是我们前面keyframes定义的动画名*/
      // animation-duration: 1s; /*动画持续时间*/
      // animation-timing-function: ease; /*动画频率，和transition-timing-function是一样的*/
      // animation-delay: 0s; /*动画延迟时间*/
      // animation-iteration-count: infinite; /*定义循环资料，infinite为无限次*/
      // animation-direction: normal; /*定义动画方式*/
    }
    .loc {
      width: 19px;
      height: 25px;
      top: -25px;
      left: -5px;
      z-index: 99;
      
      position: absolute;
      transition: all .3s;
      background-repeat: no-repeat;
      background-size: 19px 25px;
      background-position: center;
      background-image: url("../../../assets/home/globalnetwork/loc.png");
     
    }
    .locx {
       width: 19px;
      height: 25px;
      top: -25px;
      left: -5px;
      z-index: 99;
      
      position: absolute;
      transition: all .3s;
      background-repeat: no-repeat;
      background-size: 19px 25px;
      background-position: center;
      background-image: url("../../../assets/home/globalnetwork/locx.png");
      
    }

    @keyframes ripple {
      0% {
        opacity: 1;
        -webkit-transform: scale(0.1, 0.1);
        -moz-transform: scale(0.1, 0.1);
        -ms-transform: scale(0.1, 0.1);
        transform: scale(0.1, 0.1);
      }
      100% {
        opacity: 0;
        -webkit-transform: scale(4);
        -moz-transform: scale(4);
        -ms-transform: scale(4);
        transform: scale(4);
      }
    }

    @-webkit-keyframes ripple {
  
      0% {
        opacity: 0;
        -webkit-transform: scale(0.1, 0.1);
        -moz-transform: scale(0.1, 0.1);
        -ms-transform: scale(0.1, 0.1);
        transform: scale(0.1, 0.1);
      }
      5% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -webkit-transform: scale(4);
        -moz-transform: scale(4);
        -ms-transform: scale(4);
        transform: scale(4);
      }
    }

    @-moz-keyframes ripple {
   
      0% {
        opacity: 0;
        -webkit-transform: scale(0.1, 0.1);
        -moz-transform: scale(0.1, 0.1);
        -ms-transform: scale(0.1, 0.1);
        transform: scale(0.1, 0.1);
      }
      5% {
        opacity: 1;
      }
      100% {
        opacity: 0;
        -webkit-transform: scale(4);
        -moz-transform: scale(4);
        -ms-transform: scale(4);
        transform: scale(4);
      }
    }
  }
  .glb-data {
    padding-top: 10px;
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: center;
    .glb-data-item {
      width: 210px;
      height: 120px;
      padding: 18px;
      border: 1px solid #aba1a2;
      text-align: center;

      span.num {
        font-size: 50px;
        color: #b81c22;
      }
      span.plus {
        font-size: 40px;
        color: #b81c22;
      }
      p.desc {
        font-size: 24px;
        color: #3b3435;
      }
      // background-color: #ccc;
    }
  }
}
.add {
  height: 260px;
  text-align: center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  background-image: url("../../../assets/home/globalnetwork/addpic.png");
  >span {
    display: inline-block;
    width: 415px;
    height: 32px;
    margin: 0 auto;
    margin-top: 120px;
    color: #fff;
    font-size: 26px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/home/components/globalnetwork.vue